import { Suspense, lazy, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styles from './ModulesPanel.module.css'
import CommonFallback from '@/shared/components/CommonFallback'
import SubscriptionActionsContainer from '../SubscriptionActionsPanel/SubscriptionActionsContainer'
import CommentsContainer from '@/containers/SubscriptionFormPage/CommentsPanel/CommentsContainer'
import useBusinessType from '@/shared/hooks/useBusinessType'
import * as Sentry from '@sentry/react'

const ModulesPanel = ({ country, applicationType }) => {
  const { getApplicationTypeFolder } = useBusinessType({
    loaderRoutesEnergy: {},
    loaderRoutes: {},
    loaderRoutesInsurance: {},
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })
  const [CurrentLayout, setCurrentLayout] = useState(false)
  const importLocalizedLayout = async () => {
    try {
      const folder = getApplicationTypeFolder()
      const countryFolder = country.toUpperCase()
      const module = lazy(() => import(`./Layouts/${folder}/${countryFolder}/Layout.jsx`))
      setCurrentLayout(module)
    } catch (error) {
      if (import.meta.env.PROD) {
        Sentry.captureException(new Error('Error importing localized layout'), { extra: { error } })
      }
    }
  }

  useEffect(() => {
    importLocalizedLayout()
  }, [country, applicationType])

  if (!CurrentLayout) {
    return (
      <div className={styles.ModulesPanel}>
        <CommonFallback />
      </div>
    )
  }

  return (
    <div className={styles.ModulesPanel}>
      <Suspense fallback={<CommonFallback />}>
        <CurrentLayout />
      </Suspense>
      <SubscriptionActionsContainer />
      <CommentsContainer />
    </div>
  )
}

ModulesPanel.propTypes = {
  country: PropTypes.string,
  applicationType: PropTypes.string,
}

export default ModulesPanel
